export default {
  GET_NAV_TOP_MENU: 'GET_NAV_TOP_MENU',
  GET_NAV_LEFT_MENU: 'GET_NAV_LEFT_MENU',
  GET_REGION: 'GET_REGION',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_ACCOUNT_REMAINDER: 'GET_ACCOUNT_REMAINDER',
  GET_MESSAGE_COUNT: 'GET_MESSAGE_COUNT',
  GET_UNREAD_MESSAGE: 'GET_UNREAD_MESSAGE',
  GET_PENDING_ORDER: 'GET_PENDING_ORDER',
  UPDATE_NAV_LEFT_MEUN: 'UPDATE_NAV_LEFT_MEUN'
}
